export default () => ({
  isMobile: true,
  isSmallMobile: true,
  isExtraSmallMobile: true,
  isAdhdFocusActive: true
})
